export class BulkProjectResponse {
  totalProjectsPassed?: number;
  totalProjectsFailed?: number;
  fileContent?: string;

  constructor(options: {
    totalProjectsPassed?: number;
    totalProjectsFailed?: number;
    fileContent?: string;
  } = {}) {
    this.totalProjectsPassed = options.totalProjectsPassed;
    this.totalProjectsFailed = options.totalProjectsFailed;
    this.fileContent = options.fileContent;
  }
}
